module.exports = __webpack_public_path__ + "img/pay_money@3x.9aa37f04.png";